import { render, staticRenderFns } from "./keji.vue?vue&type=template&id=40526474&scoped=true&"
import script from "./keji.vue?vue&type=script&lang=js&"
export * from "./keji.vue?vue&type=script&lang=js&"
import style0 from "./keji.vue?vue&type=style&index=0&id=40526474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40526474",
  null
  
)

export default component.exports